import React from 'react';
import { FormProvider, useFormContext } from 'react-hook-form';
import WorkSampleAnswerKey from '@punchcard/core/components/exams/WorkSampleAnswerKey';
import PageButton from '@punchcard/core/components/WorkSample/PageButton';
interface IWorkSampleExamProps {
	includeExam: boolean;
	setIncludeExam: React.Dispatch<React.SetStateAction<boolean>>;
	isWorkSampleReview?: boolean;
	isPreparing?: boolean;
}

const WorkSampleExam = (props: IWorkSampleExamProps) => {
	const methods = useFormContext<WIPForm>();
	const examName = methods.watch('examName');
	const { includeExam, setIncludeExam, isWorkSampleReview, isPreparing } = props;

	const handleAddToSample = async () => {
		if (includeExam === true) {
			setIncludeExam(false);
		} else {
			setIncludeExam(true);
		}
	};
	return (
		<div className=" position-relative bg-white mb-2">
			{!includeExam &&
				<div id="divoverlay" className="workSampleOverlay"></div>
			}
			<div className="d-flex flex-column flex-grow-1 overflow-hidden m-3 pb-3">

				<h4 className="mb-4">{examName}</h4>
				<FormProvider {...methods}>
					<WorkSampleAnswerKey isSubmitted={true} />
				</FormProvider>
				{isWorkSampleReview &&
					<div className="mt-3">
						<PageButton includeItem={includeExam} handleAddToSample={handleAddToSample} isFinalGrade={true} isPreparing={isPreparing} />
					</div>
				}
			</div>
		</div>
	);
};

export default WorkSampleExam;